import { render, staticRenderFns } from "./AssignHealthReport.vue?vue&type=template&id=78ccc1b6&scoped=true"
import script from "./AssignHealthReport.vue?vue&type=script&lang=js"
export * from "./AssignHealthReport.vue?vue&type=script&lang=js"
import style0 from "./AssignHealthReport.vue?vue&type=style&index=0&id=78ccc1b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ccc1b6",
  null
  
)

export default component.exports